// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	LOGOUT_USER,
	PETTY_CASH_LOAD_PETTY_CASH_TOPBAR,
	PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS,

} from '../actions';

const INIT_STATE = {

	pettyCashLoading: false,
	pettyCashTopbarData: {},
	pettyCashList: [],

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case PETTY_CASH_LOAD_PETTY_CASH_TOPBAR:
			return { ...state, pettyCashLoading: true, }
		case PETTY_CASH_LOAD_PETTY_CASH_TOPBAR_SUCCESS:
			return {
				...state,
				pettyCashLoading: false,
				pettyCashTopbarData: action.payload,
				pettyCashList: (action.payloadList || [])
			}
		case LOGOUT_USER:
			return {
				...state,
				pettyCashLoading: false,
				pettyCashTopbarData: {},
				pettyCashList: [],
			};

		default: return { ...state };
	}
}